import { useEffect, useState } from 'react';
import axios from 'axios';
import { useCookies } from 'react-cookie'
import { api } from '../../common/api' 
import { useParams } from 'react-router-dom';
import { ACCESS_TOKEN } from '../../common/util' 

function useGetProgramDetail() { 
    const { programId } = useParams<{ programId: string }>();
    const baseUrl = api.base_url;
    const [cookies, setCookie, removeCookie] = useCookies([ACCESS_TOKEN]);
    const [programDetail, setProgramDetail] = useState<ProgramDetail>();
    const [programDetailResult, setProgramDetailResult] = useState(false);

    type ProgramDetail = {
        code: number;
        data: {
          detailLevel: number;
          guideImage: string;
          guideImageName: string;
          programArea: string;
          programId: number;
          programLevel: string;
          programName: string;
          programDetail: string;
        };
        dataList: null;
        message: string;
        success: boolean;
      };
    
    const getProgramDetail = async () => {
        try {
            const response = await axios(`${baseUrl}/program/admin-detail/${programId}`, {
                method: 'GET',
                headers: {
                  'Content-Type': 'application/json',
                  'Authorization': `Bearer ${cookies[ACCESS_TOKEN]}`,
                },
            });
            setProgramDetail(response.data)
            setProgramDetailResult(true);
        } catch (error) {
            console.error(error);
        }
    };

    return { getProgramDetail, programDetail, programDetailResult };
}

export default useGetProgramDetail;
